module.exports = __webpack_public_path__ + "img/icon-contract-enable.9f009591.svg";